import React from 'react';
import { SbEditableContent } from 'storyblok-react';
import { blokToComponent } from '../helpers';
import { Props } from '../types';

type PageProps = Props<{ body: SbEditableContent[] }>;

export const PageProduct = ({ blok, getComponent }: PageProps): JSX.Element => {
  const productList = {
    // eslint-disable-next-line no-underscore-dangle
    _uid: `${blok._uid}-product-list`,
    component: 'roche-product-list',
    headline: blok.system && blok.system[0] ? blok.system[0].headline : null,
    products: blok.system && blok.system[0] ? blok.system[0].products || [] : [],
  };

  return (
    <>
      {/* stage */}
      {blok.stage && blokToComponent({
        blok: {
          // eslint-disable-next-line no-underscore-dangle
          _uid: `${blok._uid}-grid-1`,
          component: 'roche-grid-12',
          slotted: blok.stage,
        },
        getComponent,
      })}

      {/* general */}
      {/* eslint-disable-next-line no-irregular-whitespace */}
      {blok.general && blok.general.map((item) => blokToComponent({ blok: item, getComponent }, 'general'))}

      {/* specification */}
      {/* eslint-disable-next-line no-irregular-whitespace */}
      {blok.specification.length > 0 && blokToComponent({
        blok: {
          // eslint-disable-next-line no-underscore-dangle
          _uid: `${blok._uid}-grid-3`,
          component: 'roche-grid-12',
          slotted: blok.specification,
        },
        getComponent,
      })}

      {/* system */}
      {blok.system.length > 0 && blokToComponent({
        blok: productList,
        getComponent,
      })}

      {/* further information */}
      {blok.further_information
        && blok.further_information[0]
        && blok.further_information_headline && (
        <roche-grid layout="12">
          <roche-headline level={2} headline={blok.further_information_headline} />
        </roche-grid>
      )}

      {blok.further_information.length > 0 && blokToComponent({
        blok: {
          // eslint-disable-next-line no-underscore-dangle
          _uid: `${blok._uid}-grid-4`,
          component: 'roche-grid-4-4-4',
          // eslint-disable-next-line max-len
          slotted_left: blok.further_information && blok.further_information[0] ? [blok.further_information[0]] : [],
          // eslint-disable-next-line max-len
          slotted_center: blok.further_information && blok.further_information[1] ? [blok.further_information[1]] : [],
          // eslint-disable-next-line max-len
          slotted_right: blok.further_information && blok.further_information[2] ? [blok.further_information[2]] : [],
        },
        getComponent,
      })}
    </>
  );
};
